import BaseClient from './BaseClient';
import axios from '~/services/axios';

class AdminGroupsClient extends BaseClient {
    async listGroups(params = {}) {
        return this.makeCoreApiRequest('/api/admin/groups', 'get', null, params);
    }

    async showGroup(teamId, groupId) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    async createGroup(teamId, data) {
        const url = `/api/admin/teams/${teamId}/groups`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    async updateGroup(teamId, groupId, data) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    async deleteGroup(teamId, groupId) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    async favoriteGroup(teamId, groupId) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/favorite`;
        return this.makeCoreApiRequest(url, 'post');
    }

    async deleteFavoriteGroup(teamId, groupId) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/favorite`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    async getHubspotCompanyId(teamId, groupId) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/hubspot-company-id`;
        return this.makeCoreApiRequest(url, 'get');
    }

    async updateHubspotCompanyId(teamId, groupId, data) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/hubspot-company-id`;
        return this.makeCoreApiRequest(url, 'patch', data);
    }

    async updateStatus(teamId, groupId, data) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/status`;
        return this.makeCoreApiRequest(url, 'patch', data);
    }

    async getScheduledStatusUpdate(teamId, groupId) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/scheduled-status-change`;
        return this.makeCoreApiRequest(url, 'get');
    }

    async scheduleStatusUpdate(teamId, groupId, data) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/scheduled-status-change`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    async cancelScheduledStatusUpdate(teamId, groupId) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/scheduled-status-change`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    async enableBilling(teamId, groupId) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/billing-enable`;
        return this.makeCoreApiRequest(url, 'post');
    }

    async updateBillingOptions(teamId, groupId, data) {
        const url = `/api/admin/teams/${teamId}/groups/${groupId}/billing-options`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    generateImportPresignedUrl(teamId, fileName) {
        const url = `/api/admin/teams/${teamId}/groups/upload-urls`;

        return this.makeCoreApiRequest(url, 'post', {
            original_file_name: fileName,
        });
    }

    importCsvFileToS3(preSignedS3Url, file) {
        return axios.put(preSignedS3Url, file, {
            headers: {
                'Content-Type': 'text/csv',
            },
        });
    }
}

export default new AdminGroupsClient();
